import { userProfileConstants } from '../../_constants';

const initialState = { demographicDataLoading: true, data: '', error: false };

export function getDemographicData(state = initialState, action) {
    
    switch (action.type) {
        case userProfileConstants.REQUEST_DEMOGRAPHIC_DATA:
            return {
                demographicDataLoading: true,
                data: '',
                error: false
            };
        case userProfileConstants.RECEIVE_DEMOGRAPHIC_DATA:
            return {
                demographicDataLoading: false,
                data: action.getDemographicData,
                error: false
            };
        case userProfileConstants.DEMOGRAPHIC_DATA_ERROR:
            return {
                demographicDataLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/userProfile/getDemographicData.reducer.js